module.exports = __webpack_public_path__ + "img/cama-1plaza-media.8bb796ec.svg";